import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseModalContainer, UserService, ModalService, ModalContainerService } from 'yt-ng-framework';
import { KalendarNeradnihDana } from './kalendar-neradnih-dana';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-kalendar-neradnih-dana',
  templateUrl: './kalendar-neradnih-dana.component.html'
})
export class KalendarNeradnihDanaComponent extends BaseModalContainer<KalendarNeradnihDana> implements OnInit {

  // calendarOptions: CalendarOptions;
  // displayEvent: any;
  // events = null;
  // @ViewChild(FullCalendarComponent) ucCalendar: FullCalendarComponent;

  constructor(
    protected modalContainerService: ModalContainerService<KalendarNeradnihDana>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
    // this.calendarOptions = {
    //   editable: true,
    //   headerToolbar:{
    //     left: 'prev,next today',
    //     center: 'title',
    //     right: 'month,agendaWeek,agendaDay,listMonth'
    //   },
    //   events:[]
    // }
  }

  // loadevents() {
  //   this.eventService.getEvents().subscribe(data => {
  //     this.events = data;
  //   });
  // }
  // clickButton(model: any) {
  //   this.displayEvent = model;
  // }
  // dayClick(model: any) {
  //   console.log(model);
  // }
  // eventClick(model: any) {
  //   model = {
  //     event: {
  //       id: model.event.id,
  //       start: model.event.start,
  //       end: model.event.end,
  //       title: model.event.title,
  //       allDay: model.event.allDay
  //       // other params
  //     },
  //     duration: {}
  //   }
  //   this.displayEvent = model;
  // }
  // updateEvent(model: any) {
  //   model = {
  //     event: {
  //       id: model.event.id,
  //       start: model.event.start,
  //       end: model.event.end,
  //       title: model.event.title
  //       // other params
  //     },
  //     duration: {
  //       _data: model.duration._data
  //     }
  //   }
  //   this.displayEvent = model;
  // }
}
